import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bg-gray-light" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "category-browse__finishes-bar" }
const _hoisted_4 = { class: "category-browse__select-finish" }
const _hoisted_5 = { class: "category-browse__finish-name" }
const _hoisted_6 = { class: "text-gotham-bold" }
const _hoisted_7 = { class: "category-browse__finish-list" }
const _hoisted_8 = { class: "category-browse__finish-list-ul" }
const _hoisted_9 = ["data-index", "onClick", "onMouseenter", "onMouseleave"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "category-browse__finish-checkbox" }
const _hoisted_12 = { class: "form-check me-2" }
const _hoisted_13 = {
  class: "form-check-label",
  for: "showWholesaleProducts"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "tooltip js-tooltip",
  "data-tooltip-content": "#tooltip1-content"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-help-circle" })
], -1 /* HOISTED */)
const _hoisted_15 = {
  class: "tooltip-hidden-content",
  id: "tooltip1-content"
}
const _hoisted_16 = { class: "tooltip-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString($props.translations.Finish) + ": ", 1 /* TEXT */),
              _createElementVNode("span", _hoisted_6, _toDisplayString($setup.hoveredName || $setup.store.state?.selectedFinish?.name), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("ul", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.productFinishes, (finish, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  "data-index": index,
                  class: _normalizeClass([$setup.store.state?.selectedFinish?.name === finish?.name && 'active-finish', `category-browse__finish-list-li`]),
                  onClick: ($event: any) => ($setup.setSelectedFinish(finish)),
                  onMouseenter: ($event: any) => ($setup.setTempName(finish)),
                  onMouseleave: ($event: any) => ($setup.removeTempName(finish))
                }, [
                  _createElementVNode("img", {
                    src: finish?.thumbnailUrl,
                    class: "category-browse__finish-list-img"
                  }, null, 8 /* PROPS */, _hoisted_10)
                ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_9))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.showWholesale) = $event)),
              type: "checkbox",
              value: "",
              id: "showWholesaleProducts"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelCheckbox, $setup.showWholesale]
            ]),
            _createElementVNode("label", _hoisted_13, _toDisplayString($props.translations.ShowWholesaleProductsOnly), 1 /* TEXT */)
          ]),
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString($props.translations.WholesaleProductsTooltip), 1 /* TEXT */)
          ])
        ])
      ])
    ])
  ]))
}